<!--Vista que muestra los eventos disponibles de todos los organizadores-->
<template>
  <v-container fluid class="pa-0">
    <v-row justify="center" align="center" class="mt-5 py-5">
      <v-col cols="12">
        <h1 class="display-2 text-center font-weight-bold">Eventos</h1>
      </v-col>
      <!-- SECCIÓN PARA LOS FILTROS DE LOS EVENTOS -->
      <!--<v-col cols="12" class="row justify-center">
        <v-btn-toggle v-model="category_filter" dark>
          <v-btn
            value="Capacitación / Curso / Taller"
            color="primary"
          >Capacitación / Curso / Taller</v-btn>
          <v-btn value="Congreso / Foro / Expo" color="primary">Congreso / Foro / Expo</v-btn>
          <v-btn value="Diplomados / Maestrías" color="primary">Diplomados / Maestrías</v-btn>
        </v-btn-toggle>
      </v-col>-->
      <!-- (INICIO) BUSCARDOR DE EVENTOS -->
      <v-col cols="10" sm="8" md="6" lg="5" class="mx-5">
          <v-text-field
            solo
            style="font-weight: bold;"
            outlined
            v-model="name_filter"
            append-icon="search"
            single-line
            hide-details
            class="mx-3"
            :label="($vuetify.breakpoint.smAndDown)?'Buscar evento':'Buscar por organizador, evento o palabras clave de evento'"
          ></v-text-field>
      </v-col>
      <!-- (FIN) BUSCARDOR DE EVENTOS -->
      <!--
      <v-col cols="10" sm="8" md="4" lg="3" xl="2" class="mx-5">
        <v-select
          v-model="subcategory_filter"
          :items="categoriesItems"
          item-text="item"
          item-value="value"
          label="Tema"
          prepend-icon="fas fa-filter"
        >
         <-- Template for render selected data --
        <template
          slot="selection"
          slot-scope="data"
        >
          <span>{{ data.item.item }}</span>
        </template>
            <template
              slot="item"
              slot-scope="data"
            >
            <-- Divider and Header--
            <span @click.stop class="font-weight-bold text-uppercase" v-if="data.item.item.includes('HEADER')">
              {{ data.item.item.split('#')[1] }}
              <hr/>
            </span>
            <-- Normal item --
            <span v-else>
              {{ data.item.item }}
            </span>
          </template>
        </v-select>
      </v-col>
      <v-col cols="10" sm="8" md="4" lg="3" xl="2" class="mx-5">
        <v-select
          v-model="modality_filter"
          :items="typeItems"
          item-text="item"
          item-value="value"
          label="Modalidad"
          prepend-icon="fas fa-user"
        ></v-select>
      </v-col>-->
      <!-- SECCIÓN PARA LOS FILTROS DE LOS EVENTOS -->

      <!-- SECCIÓN CON LA LISTA DE EVENTOS -->
      <v-col cols="12" md="11" xl="10">
        <product-list :items="filteredEvents" :loading="loading" itemsPerPage=8></product-list>
      </v-col>
      <!-- SECCIÓN CON LA LISTA DE EVENTOS -->
    </v-row>
    <w-footer></w-footer>
  </v-container>
</template>

<script>
import productList from "@/components/shared/products/productList";
import wFooter from "@/components/shared/w-footer";
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
export default {
  components: {
    productList,
    wFooter
  },
  data() {
    return {
      loading: true,
      eventName: "",
      categoriesItems: [
        { item:'Todos', value:'Todos' },
        { item:'HEADER#Ciencias Físico Matemáticas e Ingenierías', value:'Ciencias Físico Matemáticas e Ingenierías' },
        { item:'Ingeniería Mecánica', value:'Ingeniería Mecánica' },
        { item:'Ingeniería Eléctrica', value:'Ingeniería Eléctrica' },
        { item:'Química', value:'Química' },
        { item:'Medio ambiente y sustentabilidad', value:'Medio ambiente y Sustentabilidad' },
        { item:'Física y Astronomía', value:'Física y Astronomía'},
        { item:'Ciencias de la Computación', value:'Ciencias de la Computación'},
        { item:'Tecnologías de Información', value:'Tecnologías de Información'},
        { item:'HEADER#Ciencias Biológicas y de la Salud', value:'Ciencias Biológicas y de la Salud'},
        { item:'Medicina', value:'Medicina'},
        { item:'Nutrición', value:'Nutrición'},
        { item:'Fisioterapia', value:'Fisioterapia'},
        { item:'Odontología', value:'Odontología'},
        { item:'Salud Animal', value:'Salud Animal'},
        { item:'Enfermería', value:'Enfermería'},
        { item: "Belleza", value: "Belleza" },
        { item:'HEADER#Ciencias Sociales', value:'Ciencias Sociales'},
        { item:'Economía', value:'Economía'},
        { item:'Educación', value:'Educación'},
        { item:'Gobierno', value:'Gobierno'},
        { item:'Derecho', value:'Derecho'},
        { item:'HEADER#Negocios', value:'Negocios'},
        { item:'Finanzas', value:'Finanzas'},
        { item:'Contabilidad', value:'Contabilidad'},
        { item:'Marketing', value:'Marketing'},
        { item:'Estrategia', value:'Estrategia'},
        { item:'Gestión', value:'Gestión'},
        { item:'Diseño', value:'Diseño'},
        { item:'Manufactura', value:'Manufactura'},
        { item:'HEADER#Humanidades y de las Artes', value:'Humanidades y de las Artes'},
        { item:'Música', value:'Música'},
        { item:'Artes Plásticas', value:'Artes Plásticas'},
        { item:'Historia', value:'Historia'},
        { item:'Filosofía', value:'Filosofía'},
        { item:'HEADER#Multidisciplinaria', value:'Multidisciplinaria'},
        { item:'Emprendimiento', value:'Emprendimiento'},
        { item:'Habilidades Blandas', value:'Habilidades Blandas'},
        { item:'Industria 4.0', value:'Industria 4.0'},
        { item:'HEADER#Desarrollo Personal', value:'Desarrollo Personal'},
        { item:'Idiomas', value:'Idiomas'},
        { item:'Oratoria', value:'Oratoria'},
        { item:'Comunicación', value:'Comunicación'},
        { item:'Ortografía', value:'Ortografía'},
        { item:'Trabajo en Equipo', value:'Trabajo en Equipo'},
        { item:'Liderazgo', value:'Liderazgo'},
      ],
      typeItems: [
        { item:'Todas', value:"Todas" },
        { item:'Presencial', value:"ON_SITE" },
        { item:'En línea', value:"ON_LINE" },
      ]
    };
  },
  methods: {
    ...mapMutations("event", ["setFilter"]),
    ...mapActions("event", ["fetchEvents"]),
    async search(eventName){
      this.filteredEvents = await this.filteredEvents.map ( (event) => {
        if ( event.name.includes(eventName) ) {
          return event;
        }
      });
    }
  },
  computed: {
    ...mapGetters("event", ["filteredEvents"]),
    category_filter: {
      get() {
        return "";
      },
      set(value) {
        this.setFilter({
          filter: "category",
          value: value
        });
      }
    },
    subcategory_filter: {
      get() {
        return "Todos";
      },
      set(value) {
        this.setFilter({
          filter: "subcategory",
          value: value
        });
      }
    },
    modality_filter: {
      get() {
        return "Todas";
      },
      set(value) {
        this.setFilter({
          filter: "modality",
          value: value
        });
      }
    },
    name_filter: {
      get() {
        return "";
      },
      set(value) {
        this.setFilter({
          filter: "name",
          value: value
        });
      }
    }
  },
  async mounted() {
    await this.fetchEvents();
    this.loading=false;
  },
  destroyed() {
    this.category_filter = "";
    this.name_filter = "";
    this.modality_filter = "Todas";
    this.subcategory_filter = "Todos";
  }
};
</script>
<style scoped>
@media (max-width: 959px) {
  .v-btn-toggle {
    flex-direction: column !important;
  }
}
</style>